import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { allApis } from "../../../request/config";
import apiRequest from "../../../request/apiRequest/apiRequest";
import { ObjectValues } from "../../../pages/login";
const sorts = [
  { id: "reported_at", name: "Last Reported Time" },
  // { id: "goal", name: "Goal" },
  // { id: "section", name: "Section" },
  // { id: "topic", name: "Topic" },
  // { id: "subtopic", name: "Subtopic" },
  { id: "assigned_to", name: "Assigned To" },
  { id: "reviewed_at", name: "Reviewed At" },
  { id: "modified_at", name: "Modified At" },
];
const durations = [
  { name: "Today", id: "today" },
  { name: "Yesterday", id: "yesterday" },
  { name: "This Week (Mon - Sun)", id: "this_week" },
  { name: "Last Week (Mon - Sun)", id: "last_week" },
  { name: "This Month", id: "this_month" },
  { name: "Last Month", id: "last_month" },
  { name: "Custom", id: "custom" },
];interface ReportedBy {
  id: number | string;
  full_name: string;
  phone: string | number;
}

interface Goal {
  id: number;
  name: string;
}

interface Section {
  id: number;
  name: string;
}

interface Topic {
  id: number;
  name: string;
}

interface Subtopic {
  id: number;
  name: string;
}

export interface ReportedDataRow {
  question_id: number;
  question?:string
  total_reports: number;
  reported_contents: string;
  goal: Goal;
  section: Section;
  topic: Topic;
  subtopic: Subtopic;
  reviewed_before: boolean;
  report_source: string | null;
  reported_by: ReportedBy;
}

// Define the initial state
interface ContentFeedbackState {
  reportedQuestions: any;
  reportedQuestionsCount: {
    pending_count: number;
    reviewed_count: number;
    under_review_count: number;
    total_reported_count: number;
  };
  staffList: any[];
  questionEditData: any;
  questionEditLoading: boolean;
  reportedData:null|ReportedDataRow;
  reportedDataLoading:boolean;
  loading: boolean;
  error: string | null;
  assignStaffLoading: boolean;
  assignStaffError: string | null;
  assignStaffSuccess: boolean;
  masters: {
    goals: ObjectValues[];
    sections: ObjectValues[];
    topics: ObjectValues[];
    subtopics: ObjectValues[];
    clusters: ObjectValues[];
    staffList: ObjectValues[];
    reportedBy: ObjectValues[];
    durations: ObjectValues[];
    sorts: ObjectValues[];
    exams: ObjectValues[];
  };
  loadingCount: number;
  countLoading:boolean,
}

const initialState: ContentFeedbackState = {
  reportedQuestions: [],
  staffList: [],
  countLoading:true,
  reportedQuestionsCount: {
    pending_count: 0,
    reviewed_count: 0,
    under_review_count: 0,
    total_reported_count: 0,
  },
  reportedData:null,reportedDataLoading:false,

  questionEditData: {},
  loading: false,
  questionEditLoading: false,
  error: null,
  assignStaffLoading: false,
  assignStaffError: null,
  assignStaffSuccess: false,
  masters: {
    goals: [],
    sections: [],
    topics: [],
    subtopics: [],
    clusters: [],
    staffList: [],
    reportedBy: [],
    sorts: sorts,
    durations: durations,
    exams: [],
  },
  loadingCount: 0,
};

// Async thunk to fetch the reported questions based on review_status
export const fetchReportedQuestions = createAsyncThunk(
  "contentFeedback/fetchReportedQuestions",
  async ({ state, page }: { state: string; page: number }) => {
    try {
      const response: any = await apiRequest({
        api: allApis.getReportedQuestion(state, page),
        method: "GET",
      });
      return response ?? { results: [] }; // Assuming the API returns the data directly
    } catch (error: any) {
      return null;
    }
  }
);
export const fetchReportedBy = createAsyncThunk(
  "contentFeedback/fetchAllMasters",
  async ({ api }: any) => {
    try {
      const reportedby: any = await apiRequest({
        api: api,
        method: "GET",
      });
      return {
        reportedBy: [...(reportedby ?? [])].map((s) => {
          return { ...s, full_name_id: `#${s.id} ${s.full_name} - ${s.phone}` };
        }),
      }; // Assuming the API returns the data directly
    } catch (error: any) {
      return null;
    }
  }
);

export const fetchAllExams = createAsyncThunk(
  "contentFeedback/fetchAllExams",
  async () => {
    try {
      const exams: any = await apiRequest({
        api: allApis.getallExams(),
        method: "GET",
      });

      return { exams: [...(exams ?? [])] }; // Assuming the API returns the data directly
    } catch (error: any) {
      return null;
    }
  }
);
export const fetchAllGoals = createAsyncThunk(
  "contentFeedback/fetchAllGoals",
  async (exam: string) => {
    try {
      if(exam){
      const goals: any = await apiRequest({
        api: allApis.getGoalList(exam),
        method: "GET",
      });

      return { goals: [...(goals ?? [])] }; // Assuming the API returns the data directly
      }else{
        

      return { goals:[]}; // Assuming the API returns the data directly
      }
    } catch (error: any) {
      return null;
    }
  }
);
export const fetchAllSections = createAsyncThunk(
  "contentFeedback/fetchAllSections",
  async (goal_id?: string) => {
    try {
      if(goal_id){
      const sections: any = await apiRequest({
        api: allApis.getSectionList(goal_id),
        method: "GET",
      });
      return { sections: [...(sections ?? [])] }; // Assuming the API returns the data directly
      }else{
           return { sections: []}; // Assuming the API returns the data directly
     
      }
    } catch (error: any) {
      return null;
    }
  }
);
export const fetchALLTopics = createAsyncThunk(
  "contentFeedback/fetchALLTopics",
  async (section?: string) => {
    try {if(section){
      const topics: any = await apiRequest({
        api: allApis.getTopicsList(section),
        method: "GET",
      });
      return { topics: [...(topics ?? [])] }; // Assuming the API returns the data directly
        }else{
        
      return { topics: [] };
      }
    } catch (error: any) {
      return null;
    }
  }
);
export const fetchAllSubtopics = createAsyncThunk(
  "contentFeedback/fetchALLTopics",
  async (topic?: string) => {
    try {if(topic){
      const subtopics: any = await apiRequest({
        api: allApis.getSubtopicslist(topic),
        method: "GET",
      });
      return { subtopics: [...(subtopics ?? [])] }; // Assuming the API returns the data directly
      }else{
        
      return { subtopics: [] };
      }
    } catch (error: any) {
      return null;
    }
  }
);
export const fetchAllClusters = createAsyncThunk(
  "contentFeedback/fetchALLTopics",
  async (subtopic?: string) => {
    try {
      if(subtopic){
      const clusters: any = await apiRequest({
        api: allApis.getClustersList(subtopic),
        method: "GET",
      });
      return { clusters: [...(clusters ?? [])] }; // Assuming the API returns the data directly
      }else{
        return { clusters:[]};
      }
    } catch (error: any) {
      return null;
    }
  }
);
// Async thunk to fetch the reported questions based on review_status
export const fetchReportedQuestionsCount = createAsyncThunk(
  "contentFeedback/fetchReportedQuestionsCount",
  async ({ api }: { api: string }) => {
    try {
      const response: any = await apiRequest({ api: api, method: "GET" });
      return response ?? { results: [] }; // Assuming the API returns the data directly
    } catch (error: any) {
      return null;
    }
  }
);

// create get staff list slice
export const fetchStaffList = createAsyncThunk(
  "contentFeedback/fetchStaffList",
  async () => {
    try {
      const response: any = await apiRequest({
        api: allApis.getStaffList(),
        method: "GET",
      });
      return response ?? [];
    } catch (error: any) {
      return null;
    }
  }
);

export const fetchSinlgQustion = createAsyncThunk(
  "contentFeedback/fetchSinlgQustion",
  async (props: any) => {
    try {
      const response: any = await apiRequest(props);
      return response
        ? {
            ...response,
            languages_available:
              response.translation
                .map((s: { language: any }) => s.language)
                .join(",") ?? "english",
          }
        : null;
    } catch (error: any) {
      console.error("API Error:", error); // Add this line to catch and log any errors
      return null;
    }
  }
);
export const fetchsingleReportedData = createAsyncThunk(
  "contentFeedback/fetchsingleReportedData",
  async (props: any) => {
    try {
      const response: any = await apiRequest(props);
      return response
        ? {
            ...response}
        : null;
    } catch (error: any) {
      console.error("API Error:", error); // Add this line to catch and log any errors
      return null;
    }
  }
);

// Async thunk for patch API to assign staff
export const assignStaff = createAsyncThunk(
  "contentFeedback/assignStaff",
  async ({ row, id }: { row: any; id: any }) => {
    try {
      const response: any = await apiRequest({
        api: allApis.assignStaff(id),
        method: "PATCH",
        payload: row,
      });
      return response ?? null;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

// Async thunk for patch API to mark as no change
export const markAsNoChange = createAsyncThunk(
  "contentFeedback/markAsNoChange",
  async (row: any) => {
    try {
      const response: any = await apiRequest({
        api: allApis.markAsNoChange(row?.id, row?.notify_users),
        method: "PATCH",
        payload: {
          validator_remark: row?.validator_remark,
          review_status: "reviewed",
          action_taken: "no_change",
        }, // Add data payload
      });
      return response ?? null;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

// Async thunk for patch API to mark as corrected
export const markAsCorrected = createAsyncThunk(
  "contentFeedback/markAsCorrected",
  async (row: any) => {
    try {
      const response: any = await apiRequest({
        api: allApis.markAsCorrected(row?.id, row?.notify_users),
        method: "PATCH",
        payload: {
          validator_remark: row?.validator_remark,
          review_status: "reviewed",
          action_taken: "corrected",
        }, // Add data payload
      });
      return response ?? null;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
);

const contentFeedbackSlice = createSlice({
  name: "contentFeedback",
  initialState,
  reducers: {
    clearListData(state) {
      state.reportedQuestions = []; // Reset reportData to an empty array
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchReportedBy.pending, (state) => {
        state.loading = true;
        state.error = null;
      }).addCase(fetchReportedBy.fulfilled, (state, action) => {
        state.loading = false;
        state.masters = { ...state.masters, ...action.payload };
      }).addCase(fetchReportedBy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      }).addCase(fetchAllExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      }).addCase(fetchAllExams.fulfilled, (state, action) => {
        state.loading = false;
        state.masters = { ...state.masters, ...action.payload };
      })
      .addCase(fetchAllExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAllGoals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllGoals.fulfilled, (state, action) => {
        state.loading = false;
        state.masters = { ...state.masters, ...action.payload };
      })
      .addCase(fetchAllGoals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAllSections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllSections.fulfilled, (state, action) => {
        state.loading = false;
        state.masters = { ...state.masters, ...action.payload };
      })
      .addCase(fetchAllSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchALLTopics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchALLTopics.fulfilled, (state, action) => {
        state.loading = false;
        state.masters = { ...state.masters, ...action.payload };
      })
      .addCase(fetchALLTopics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchReportedQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReportedQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.reportedQuestions = action.payload;
      })
      .addCase(fetchReportedQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchReportedQuestionsCount.pending, (state) => {
        state.countLoading = true;
        state.error = null;
      })
      .addCase(fetchReportedQuestionsCount.fulfilled, (state, action) => {
        state.countLoading = false;
        state.reportedQuestionsCount = action.payload;
      })
      .addCase(fetchReportedQuestionsCount.rejected, (state, action) => {
        state.countLoading = false;
        state.error = action.payload as string;
      })
      // Handle fetchStaffList
      .addCase(fetchStaffList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStaffList.fulfilled, (state, action) => {
        state.loading = false;
        state.staffList = action.payload;
      })
      .addCase(fetchStaffList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch staff list";
      })
      // Handle fetchReportData
     
      // Handle fetchSinlgQustion
      .addCase(fetchSinlgQustion.pending, (state) => {
        state.questionEditLoading = true;
        state.error = null;
      })
      .addCase(fetchSinlgQustion.fulfilled, (state, action) => {
        state.questionEditLoading = false;
        state.questionEditData = action.payload;
      })
      .addCase(fetchSinlgQustion.rejected, (state, action) => {
        state.questionEditLoading = false;
        state.error = action.error.message ?? "Failed to edit data";
      }) .addCase(fetchsingleReportedData.pending, (state) => {
        state.reportedDataLoading = true;
        state.error = null;
      })
      .addCase(fetchsingleReportedData.fulfilled, (state, action) => {
        state.reportedDataLoading = false;
        state.reportedData = action.payload;
      })
      .addCase(fetchsingleReportedData.rejected, (state, action) => {
        state.reportedDataLoading = false;
        state.error = action.error.message ?? "Failed to edit data";
      })
      // Handle assignStaff
      .addCase(assignStaff.pending, (state) => {
        state.assignStaffLoading = true;
        state.assignStaffError = null;
        state.assignStaffSuccess = false;
      })
      .addCase(assignStaff.fulfilled, (state, action) => {
        state.assignStaffLoading = false;
        state.assignStaffSuccess = true;
        // Optionally update your state with the response if needed
      })
      .addCase(assignStaff.rejected, (state, action) => {
        state.assignStaffLoading = false;
        state.assignStaffError =
          action.error.message || "Failed to assign staff";
        state.assignStaffSuccess = false;
      })
      .addMatcher(
        (action) => action.type.endsWith("/pending"),
        (state) => {
          state.loadingCount++;
        }
      )
      // automatically decrement for *any* fulfilled/rejected action
      .addMatcher(
        (action) =>
          action.type.endsWith("/fulfilled") ||
          action.type.endsWith("/rejected"),
        (state) => {
          state.loadingCount = Math.max(0, state.loadingCount - 1);
        }
      );
  },
});

export const { clearListData } = contentFeedbackSlice.actions;
export default contentFeedbackSlice.reducer;
